<template>
    <div class="w-12 h-12 group relative">

        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 40 40" class="group-hover:opacity-0 absolute top-0 transition-opacity duration-150"  >
            <defs>
                <clipPath id="clippath">
                    <rect class="layer-2-cls-1" x=".35" y=".34" width="39.31" height="39.32"/>
                </clipPath>
            </defs>
            <g class="layer-2-cls-4">
                <g>
                    <path class="layer-2-cls-2" d="M20.01.84c10.58,0,19.16,8.58,19.16,19.16s-8.58,19.17-19.16,19.17c-10.58-.01-19.16-8.59-19.16-19.16S9.43.84,20.01.84Z"/>
                    <path class="layer-2-cls-3" d="M29.73,27.75h-3.5c-.28,0-.5-.22-.5-.5v-6.12c0-.33-.13-.65-.37-.88-.47-.47-1.3-.47-1.77,0-.24.24-.37.55-.37.88v6.12c0,.28-.22.5-.5.5h-3.5c-.28,0-.5-.22-.5-.5v-6.12c0-1.54.6-2.98,1.68-4.07,1.09-1.09,2.53-1.68,4.07-1.68s2.98.6,4.07,1.68c1.09,1.08,1.68,2.53,1.68,4.07v6.12c0,.28-.22.5-.5.5h.01ZM26.73,26.75h2.5v-5.62c0-1.27-.49-2.46-1.39-3.36s-2.09-1.39-3.36-1.39-2.46.49-3.36,1.39-1.39,2.09-1.39,3.36v5.62h2.5v-5.62c0-.6.23-1.17.66-1.59.84-.84,2.34-.84,3.18,0,.43.42.66.99.66,1.59v5.62Z"/>
                    <path class="layer-2-cls-3" d="M15.74,27.75h-3.5c-.28,0-.5-.22-.5-.5v-10.5c0-.28.22-.5.5-.5h3.5c.28,0,.5.22.5.5v10.5c0,.28-.22.5-.5.5ZM12.74,26.75h2.5v-9.5h-2.5v9.5Z"/>
                    <path class="layer-2-cls-3" d="M13.99,14.62c-1.24,0-2.25-1.01-2.25-2.25s1.01-2.25,2.25-2.25,2.25,1.01,2.25,2.25-1.01,2.25-2.25,2.25ZM13.99,11.12c-.69,0-1.25.56-1.25,1.25s.56,1.25,1.25,1.25,1.25-.56,1.25-1.25-.56-1.25-1.25-1.25Z"/>
                </g>
            </g>
        </svg>

        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 40 40" class="opacity-0 group-hover:opacity-100 absolute top-0 transition-opacity duration-150">
            <defs>
                <clipPath id="clippath">
                    <rect class="cls-1" x=".35" y=".34" width="39.31" height="39.32"/>
                </clipPath>
            </defs>
            <g class="cls-4">
                <g>
                    <path class="cls-2" d="M20.01.84c10.58,0,19.16,8.58,19.16,19.16s-8.58,19.17-19.16,19.17c-10.58-.01-19.16-8.59-19.16-19.16S9.43.84,20.01.84Z"/>
                    <path class="cls-3" d="M28.56,17.06c-1.09-1.09-2.53-1.68-4.07-1.68s-2.98.6-4.07,1.68c-1.09,1.09-1.68,2.53-1.68,4.07v6.12c0,.28.22.5.5.5h3.5c.28,0,.5-.22.5-.5v-6.12c0-.33.13-.65.37-.88.47-.47,1.3-.47,1.77,0,.23.23.37.55.37.88v6.12c0,.28.22.5.5.5h3.5c.28,0,.5-.22.5-.5v-6.12c0-1.54-.6-2.98-1.68-4.07h-.01Z"/>
                    <path class="cls-3" d="M15.74,16.25h-3.5c-.28,0-.5.22-.5.5v10.5c0,.28.22.5.5.5h3.5c.28,0,.5-.22.5-.5v-10.5c0-.28-.22-.5-.5-.5Z"/>
                    <path class="cls-3" d="M13.99,14.62c1.24,0,2.25-1.01,2.25-2.25s-1.01-2.25-2.25-2.25-2.25,1.01-2.25,2.25,1.01,2.25,2.25,2.25Z"/>
                </g>
            </g>
        </svg>



    </div>
</template>

<style scoped>
<style>
.cls-1, .cls-2 {
    fill: none;
}

.cls-3 {
    fill: #242653;
}

.cls-2 {
    stroke: #242653;
}

.cls-4 {
    clip-path: url(#clippath);
}

.layer-2-cls-1, .layer-2-cls-2 {
    fill: none;
}

.layer-2-cls-3 {
    fill: #242653;
}

.layer-2-cls-2 {
    stroke: #242653;
}

.layer-2-cls-4 {
    clip-path: url(#clippath);
}
</style>
<script setup lang="ts">
</script>